import axios from 'axios';

// helpers
import { prepareSelectParam, prepareFilterParam, prepareSortParam } from '../lib/queryParams';

// constants
import { API_URL_NEW } from '../lib/endpoints'
import { ALLOWED_QUERY_OPERATOR, DATA_SET_TYPES } from '../lib/constants';

const userApi = {


    postReportUser: (payload) => {
        let url = `${API_URL_NEW}/user/report`

        return new Promise((resolve, reject) => {
            axios.post(url, payload)
                .then(response => {
                    if (response.data.status == 200) {
                        resolve(true)
                    }
                }).catch(err => reject(err))
        })
    },

    // getFollowedEntities: (userId, entityTypes = [], limit = 6, page = 1) => {
    //     const fields = prepareSelectParam(['id', 'entity_data']);
    //     const filters = prepareFilterParam([{ key: 'entity_type', value: entityTypes, op: ALLOWED_QUERY_OPERATOR.equal }]);
    //     const url = `${API_URL_NEW}/user/${userId}/following?fields=${fields}&filters=${filters}&limit=${limit}&page=${page}`;

    //     return new Promise((resolve, reject) => {
    //         axios.get(url)
    //             .then(response => {
    //                 resolve({
    //                     entities: response.data.data,
    //                     count: response.data.navigation.total
    //                 })
    //             }).catch(err => reject(err))
    //     });
    // },

    getResearchDownloadQuota: (userId) => {
        const url = `${API_URL_NEW}/user/${userId}/research-download-quota`;

        return new Promise((resolve, reject) => {
            axios.get(url)
                .then(response => {
                    resolve(response.data.data)
                }).catch(err => reject(err))
        });
    },

    getCompaniesList: (userId, getFields = [], getFilters = [], limit = 6, page = 1) => {
        const fields = prepareSelectParam(getFields)
        const filters = prepareFilterParam(getFilters)

        const url = `${API_URL_NEW}/user/${userId}/entity?fields=${fields}&filters=${filters}&limit=${limit}&page=${page}`

        return new Promise((resolve, reject) => {
            axios.get(url)
                .then(response => {
                    resolve({
                        records: response.data.data,
                        count: response.data.navigation.total
                    });
                })
                .catch(err => reject(err))
        })
    },

    // Get recommended people
    // getRecommendedPeople: (userId) => {
    //     const url = `${API_URL_NEW}/user/${userId}/user-recommended`
    //     return axios.get(url)
    // },

    // get user data
    getUserData: (userId) => {
        const url = `${API_URL_NEW}/user/${userId}?fields=type_data`
        return axios.get(url)
    },

    // getRecommendedStartups: (userId) => {
    //     return new Promise((resolve, reject) => {
    //         axios.get(`${API_URL_NEW}/user/${userId}/startup-recommended`)
    //             .then(async (response) => {
    //                 resolve(response.data.data)
    //             }).catch(err => {
    //                 reject(err)
    //             })
    //     })
    // },

    // data exports quota
    getDataExportQuota: (userId) => {
        const url = `${API_URL_NEW}/user/${userId}/data-export-quota`;

        return new Promise((resolve, reject) => {
            axios.get(url)
                .then(response => {
                    resolve(response.data.data)
                }).catch(err => reject(err))
        });
    },

    // data exports quota
    getDataExportFundingCount: (userId, filters, sort, limit, type) => {
        const path = (type == DATA_SET_TYPES.privateEquity) ? "data-export-transactions-count" : "data-export-funding-count";
        const url = `${API_URL_NEW}/user/${userId}/${path}?fields=id^,name^,entity_type&filters=${filters}&sort=${sort}&limit=${limit}&data_set_type=${encodeURIComponent(type)}`;

        return new Promise((resolve, reject) => {
            axios.get(url).then(response => {
                resolve(response.data.data)
            }).catch(err => reject(err))
        });
    },

    // create data export request
    postDataExportRequest: (userId, payload) => {
        const url = `${API_URL_NEW}/user/${userId}/data-export-request`

        return new Promise((resolve, reject) => {
            axios.post(url, payload)
                .then(response => {
                    if (response.data.status == 200) {
                        resolve(response.data.data);
                    }
                }).catch(err => reject(err));
        })
    },

    getUserSubscription: (userId) => {
        const fields = prepareSelectParam(['id', 'order_id', 'status', 'end_date', 'transaction_data', 'subscription_data']);
        const filters = prepareFilterParam([{ key: 'status', value: [1], op: ALLOWED_QUERY_OPERATOR.equal }]);

        const url = `${API_URL_NEW}/user/${userId}/subscription?fields=${fields}&filters=${filters}&sort=id^:desc&limit=1`;

        return new Promise((resolve, reject) => {
            axios.get(url)
                .then(response => {
                    if (response.data.status === 200) {
                        resolve(response.data.data)
                    } else {
                        reject([])
                    }
                }).catch(err => reject(err))
        })
    },

    // get user-entity follow status
    // getUserEntityFollowStatus: (entityId = "", entityType = "") => {

    //     const url = `${API_URL_NEW}/${entityType}/${entityId}/user-follow-status`;

    //     return new Promise((resolve, reject) => {
    //         axios.get(url)
    //             .then(response => {
    //                 resolve(response.data.data);
    //             }).catch(err => {
    //                 reject(err);
    //             })
    //     })
    // },

    // update user-entity follow status (follow/un-follow)
    // updateUserEntityFollowStatus: (entityId = "", entityType = "") => {
    //     const url = `${API_URL_NEW}/${entityType}/${entityId}/follow`;

    //     return new Promise((resolve, reject) => {
    //         axios.post(url)
    //             .then(response => {
    //                 resolve(response.data.data);
    //             }).catch(err => {
    //                 reject(err);
    //             })
    //     })
    // },

    // update/add new user's email
    addUserEmail: (userId = "", email = "") => {
        const payload = {
            email,
            is_primary: 1
        };

        const url = `${API_URL_NEW}/user/${userId}/email`;

        return new Promise((resolve, reject) => {
            axios.post(url, payload)
                .then(response => {
                    resolve(response.data.data);
                }).catch(err => {
                    reject(err);
                })
        })
    },

    getUserWorkHistory: (id) => {
        const fieldsArray = ['id', 'company_name', 'position', 'industry_id', 'start_date', 'end_date', 'is_current', 'created_at'];
        const fields = prepareSelectParam(fieldsArray);
        const sortParams = [{ key: 'created_at', sortVal: 'desc' }];
        const sortFilter = prepareSortParam(sortParams);

        return new Promise((resolve, reject) => {
            axios.get(`${API_URL_NEW}/user/${id}/work`, {
                params: { fields, order: sortFilter }
            }).then(data => {
                if (data.status === 200) {
                    resolve(data.data.data)
                }
            }).catch(err => reject(err));
        })
    },

    getUserEducation: (id) => {
        return new Promise((resolve, reject) => {
            axios.get(`${API_URL_NEW}/user/${id}/education`).then(data => {
                if (data.status === 200) {
                    resolve(data.data.data)
                }
            }).catch(err => reject(err));
        })
    },

    getUserOrgClientDirectory: (id, fields = []) => {

        const preparedFields = prepareSelectParam(fields.length == 0 ? [
            'id', 'title', 'type', 'organization_id', 'organization_name', 'brand_theme',
            'status', 'description', 'default_filter', 'created_by_data', 'organization_logo_data', 'logo_dimensions'] : fields)

        return new Promise((resolve, reject) => {
            axios.get(`${API_URL_NEW}/user/${id}/client-directory?fields=${preparedFields}&limit=1`).then(data => {
                if (data.status === 200) {
                    resolve(data.data.data)
                }
            }).catch(err => resolve({}));
        })
    },
}

export default userApi;
